import { FontSizes, NeutralColors } from "@fluentui/react";

interface IHeaderPanelStyle1 {
    textHeader: string;
    subTextHeader?: string;
  }
  export const PanelHeaderBasic = (props: IHeaderPanelStyle1) => {

return(
    <div
    style={{ display: "flex", flexDirection: "column", margin: "0px 20px", width:'100%' }}
  >
    <div
      style={{
        color: NeutralColors.gray130,
        fontSize: FontSizes.size20,
      }}
    >
      {props.textHeader}
    </div>
    <div
      style={{
        color: NeutralColors.gray130,
        fontSize: FontSizes.size12,
      }}
    >
      {props.subTextHeader}
    </div>
  </div>
)



  }